import { useContext } from "react";
import { Link } from "react-router-dom";

import ASELogo from "../assets/ase-logo.png";
import NavbarLink from "./NavbarLink";

import { Bars3Icon, DocumentIcon, LifebuoyIcon, UserMinusIcon, UserIcon, ArrowLeftEndOnRectangleIcon, BriefcaseIcon, ClockIcon } from "@heroicons/react/24/outline";
import { AuthContext } from "../contexts/AuthContext";
import { LabourerContext } from "../contexts/LabourerContext";

const LabourerMobileNavOverlay = ({ isOpen, onCloseClicked }) => {
  const { mutateUser, setToken } = useContext(AuthContext);
  const { mutateLabourer } = useContext(LabourerContext);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
    mutateUser(null);
    mutateLabourer(null);
  }

  return (
    <nav className={`${isOpen ? 'fixed' : 'hidden'} top-0 left-0 right-0 bottom-0 z-50 bg-white shadow-md md:hidden px-4 py-2`}>
      <div className="flex items-center justify-between mb-8">
        <Link to="/l">
          <img src={ASELogo} alt="ASE Group" className="h-[30px]" />
        </Link>

        <Bars3Icon
          className='h-8 w-8 text-ase-blue'
          onClick={onCloseClicked}
        />
      </div>

      <div className="flex flex-col gap-2 mb-4">
        <NavbarLink to="/l/clock-in" label="Clock-In" icon={<ClockIcon className="h-8 w-8 text-ase-blue" />} />
        <NavbarLink to="/l/my-work" label="My Work" icon={<BriefcaseIcon className="h-8 w-8 text-ase-blue" />} />
        <NavbarLink to="/l/licenses-and-documents" label="Licenses & Documents" icon={<DocumentIcon className="h-8 w-8 text-ase-blue" />} />
        <NavbarLink to="/l/leave-requests" label="Leave requests" icon={<UserMinusIcon className="h-8 w-8 text-ase-blue" />} />
        <NavbarLink to="/l/support" label="Support" icon={<LifebuoyIcon className="h-8 w-8 text-ase-blue" />} />
        <NavbarLink to="/l/profile" label="Profile" icon={<UserIcon className="h-8 w-8 text-ase-blue" />} />
      </div>

      <button
        onClick={handleLogout}
        className='bg-red-600 text-white font-semibold h-[36px] rounded-md w-[250px] flex items-center justify-center gap-1 text-sm'
      >
        <ArrowLeftEndOnRectangleIcon className='h-5 w-5' /> Sign out
      </button>
    </nav>
  );
}

export default LabourerMobileNavOverlay;
